import React from 'react';

const revenueData = [
  {
    schoolName: 'Green Valley High School',
    address: 'Hyderabad, Telangana',
    totalStudents: 520,
    rate:150,
    totalAmount: 78000,
    paidDate: '2026-03-25',
    paidAmount: 66000,
    balanceAmount: 12000,
    dueDate: '2026-04-10',
  },
  {
    schoolName: 'Sunrise Public School',
    address: 'Vijayawada, Andhra Pradesh',
    totalStudents: 430,
    totalAmount: 64500,
    paidDate: '2026-03-28',
    paidAmount: 56500,
    balanceAmount: 8000,
    dueDate: '2026-04-12',
  },
  {
    schoolName: 'Oxford English Medium School',
    address: 'Guntur, Andhra Pradesh',
    totalStudents: 610,
    totalAmount: 91500,
    paidDate: '2026-03-30',
    paidAmount: 76500,
    balanceAmount: 15000,
    dueDate: '2026-04-15',
  },
];

const Revenue = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Revenue Dashboard</h1>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-4 text-left">School Name</th>
                  <th className="p-4 text-left">Address</th>
                  <th className="p-4 text-left">Total Students</th>
                  <th className="p-4 text-left">Rate</th>
                  <th className="p-4 text-left">Total Amount</th>
                  <th className="p-4 text-left">Paid Amount</th>
                  <th className="p-4 text-left">Paid Date</th>
                  <th className="p-4 text-left">Balance Amount</th>
                  <th className="p-4 text-left">Due Date</th>
                </tr>
              </thead>
              <tbody>
                {revenueData.map((row, index) => (
                  <tr key={index} className="border-t hover:bg-gray-50">
                    <td className="p-4">{row.schoolName}</td>
                    <td className="p-4">{row.address}</td>
                    <td className="p-4">{row.totalStudents}</td>
                    <td className="p-4">{row.rate }</td>
                    <td className="p-4">₹{row.totalAmount.toLocaleString()}</td>
                    <td className="p-4">₹{row.paidAmount.toLocaleString()}</td>
                    <td className="p-4">{row.paidDate}</td>
                    <td className="p-4">₹{row.balanceAmount.toLocaleString()}</td>
                    <td className="p-4">{row.dueDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Revenue;
